// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { styledScrollbar } from "@bg/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    css: css`
        *:focus {
            outline: none !important;
        }
        .quick-view {
            height: 0;
            overflow: hidden;
            opacity: 0;
            transition: all 150ms;

            @media (max-width: 1024px) {
                display: none;
            }
            &&.loading {
                opacity: 1;
                height: auto;
            }
        }

        .product-card:hover {
            .quick-view {
                opacity: 1;
                height: auto;
            }
        }

        @keyframes progressBar {
            0% {
                width: 0;
            }
            100% {
                width: 100%;
            }
        }
        ul {
            margin: 0;
            padding: 0;
            list-style: inherit;
        }

        body {
            ${styledScrollbar(8, "common.ui1")};
            overflow-x: hidden; // ToDo: this is under test
        }

        .sortable-ghost {
            background: white !important;
            opacity: 0.8 !important;
        }

        .fonts-loaded body {
            font-family: "Roboto", sans-serif;
        }

        .fonts-loaded-bgs body {
            font-family: "Montserrat", sans-serif;
        }
        #browser-not-support-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            background-color: ${getColor("common.ui3")};
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 2147483647;
            > div {
                color: ${getColor("text")};
                background: ${getColor("common.white")};
                border-radius: 5px;
                padding: 30px 20px;
                max-width: 600px;
                text-align: center;
                position: relative;
                .company-logo {
                    max-width: 270px;
                    margin-bottom: 20px;
                    display: inline-block;
                    background: ${getColor("primary.main")};
                    padding: 10px;
                }
                .close-button {
                    position: absolute;
                    background-color: transparent;
                    padding: 5px;
                    top: 10px;
                    right: 10px;
                    border: none;
                    box-shadow: none;
                    cursor: pointer;
                    &:hover {
                        color: ${getColor("secondary")};
                    }
                }
                .message-title {
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .message-body {
                    margin-bottom: 20px;
                }
                .supported-browsers {
                    display: flex;
                    justify-content: center;
                    margin-top: 20px;
                    .supported-browser {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 30px;
                        margin-bottom: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                        .browser-logo {
                            position: relative;
                            width: 65px;
                            height: 65px;
                            margin-bottom: 5px;
                        }

                        img {
                            max-width: 100%;
                            max-height: 100%;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
            a {
                color: ${getColor("primary")};
                &:hover {
                    color: ${getColor("secondary")};
                }
                margin-left: 5px;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
